import { useQueryClient } from "@tanstack/react-query";
import { useToastsContext } from "@lending/hooks/useToasts";
import { useApi } from "@lending/lib/api";

const noop = () => Promise.resolve();

interface Props {
  onSuccess?: () => void | Promise<void>;
  onError?: (error: Record<string, string[]>) => void;
}
function usePatchApplicantIncomeDetailsQuery({ onSuccess = noop, onError }: Props = {}) {
  const { clearToasts } = useToastsContext();
  const $api = useApi();
  const queryClient = useQueryClient();

  return $api.useMutation("patch", "/v2/lending/applicant_income_details/{uuid}/", {
    onSuccess: async () => {
      clearToasts();
      await queryClient.invalidateQueries({
        queryKey: ["get", "/v2/lending/applicant_income_details/"],
      });
      await onSuccess();
    },
    onError,
  });
}

export { usePatchApplicantIncomeDetailsQuery };
